import React, { Suspense, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import './i18n';
import Navbar from './components/Navbar/Navbar';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import Solutions from './pages/Solutions/Solutions';
import Portfolio from './pages/Portfolio/Portfolio';
import Resources from './pages/Resources/Resources';
import Contact from './pages/Contact/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import { AdminLogin, AdminDashboard, AdminExpertise, AdminClients, AdminTimeline, AdminAchievements, AdminSolutions, AdminPortfolio, AdminResources, AdminTeam, AdminEnquiries } from './pages/Admin';
import Footer from './components/Footer/Footer';
import LanguageSwitch from './components/LanguageSwitch/LanguageSwitch';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import Loading from './components/Loading/Loading';
import './App.css';

// Component to scroll to top on route change
function ScrollToTopOnNavigate() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

// Layout component that conditionally renders Navbar/Footer
function Layout({ children }) {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  return (
    <>
      <ScrollToTopOnNavigate />
      {!isAdminRoute && <Navbar />}
      {!isAdminRoute && <LanguageSwitch />}
      {children}
      {!isAdminRoute && <Footer />}
      {!isAdminRoute && <ScrollToTop />}
    </>
  );
}

function App() {
  const { i18n, ready } = useTranslation();

  if (!ready) {
    return <Loading />;
  }

  return (
    <HelmetProvider>
      <Router>
        <div className="App" dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
          <Suspense fallback={<Loading />}>
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/solutions" element={<Solutions />} />
                <Route path="/portfolio" element={<Portfolio />} />
                <Route path="/resources" element={<Resources />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/admin" element={<AdminLogin />} />
                <Route path="/admin/dashboard" element={<AdminDashboard />} />
                <Route path="/admin/expertise" element={<AdminExpertise />} />
                <Route path="/admin/clients" element={<AdminClients />} />
                <Route path="/admin/timeline" element={<AdminTimeline />} />
                <Route path="/admin/achievements" element={<AdminAchievements />} />
                <Route path="/admin/solutions" element={<AdminSolutions />} />
                <Route path="/admin/portfolio" element={<AdminPortfolio />} />
                <Route path="/admin/resources" element={<AdminResources />} />
                <Route path="/admin/team" element={<AdminTeam />} />
                <Route path="/admin/enquiries" element={<AdminEnquiries />} />
              </Routes>
            </Layout>
          </Suspense>
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;